/* Bordamar · Hilo
   Firma visual: un pespunte rosa que se cose en cámara lenta.
   1) Bajo la palabra en rosa del titular de portada y bajo el H1 de las colecciones (al cargar).
   2) Una costura a lo ancho del bloque «Nuestro taller», que se cose con el scroll y lleva una aguja.
   Sin vídeo, sin librerías. Respeta «reducir movimiento». Si algo falla, la página queda igual. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var PINK = '#E5007D';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasTL = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
  var uid = 0;

  var css =
    '.bm-ul{position:absolute;left:0;top:0;pointer-events:none;overflow:visible;z-index:1}' +
    '.bm-hilo-host{position:relative}' +
    '.bm-seam{position:relative;max-width:1240px;margin:0 auto;height:56px;padding:0 20px;box-sizing:border-box;pointer-events:none}' +
    '.bm-seam>svg{position:absolute;left:20px;top:10px;overflow:visible}.bm-needle svg{display:block}' +
    '.bm-seam .bm-needle{position:absolute;left:20px;top:10px;width:30px;height:8px;offset-rotate:auto;offset-anchor:100% 50%;offset-distance:0%;opacity:0;will-change:offset-distance}' +
    '.bm-seam .bm-seam-cap{position:absolute;right:20px;bottom:0;font-size:.72rem;letter-spacing:.14em;text-transform:uppercase;color:rgba(255,255,255,.55);opacity:0;transform:translateY(4px);transition:opacity .6s cubic-bezier(.23,1,.32,1),transform .6s cubic-bezier(.23,1,.32,1)}' +
    '.bm-seam.is-done .bm-seam-cap{opacity:1;transform:none}' +
    '@property --bm-p{syntax:"<number>";inherits:true;initial-value:0}' +
    '@keyframes bmSeam{from{--bm-p:0}to{--bm-p:1}}' +
    '.bm-seam.tl{animation:bmSeam linear both;animation-timeline:view();animation-range:entry 15% cover 55%}' +
    '.bm-seam.tl .rv{stroke-dashoffset:calc(1 - var(--bm-p))}' +
    '.bm-seam.tl .bm-needle{offset-distance:calc(var(--bm-p) * 100%);opacity:calc(min(var(--bm-p) * 12, (1 - var(--bm-p)) * 12, 1))}' +
    '@media (prefers-reduced-motion: reduce){.bm-seam .bm-needle{display:none}.bm-seam .bm-seam-cap{opacity:1;transform:none}}';

  function addCSS() {
    if (document.getElementById('bm-hilo-css')) return;
    var s = document.createElement('style');
    s.id = 'bm-hilo-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function el(name, attrs) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  /* Onda suave «a mano»: curvas alternas arriba/abajo con pequeña irregularidad */
  function wave(w, h, amp, seg) {
    var mid = h / 2;
    var n = Math.max(2, Math.round(w / seg));
    var step = w / n;
    var d = 'M0 ' + mid.toFixed(1);
    for (var i = 1; i <= n; i++) {
      var x = step * i;
      var jitter = 0.75 + 0.25 * Math.sin(i * 2.3);
      var cy = mid + (i % 2 ? -1 : 1) * amp * 2 * jitter;
      d += ' Q' + (x - step / 2).toFixed(1) + ' ' + cy.toFixed(1) + ' ' + x.toFixed(1) + ' ' + mid.toFixed(1);
    }
    return d;
  }

  /* SVG con pespunte enmascarado: la máscara (rv) se «cose» de 0 a 1 */
  function stitchSVG(w, h, d, o) {
    var id = 'bmhm' + ++uid;
    var svg = el('svg', { width: w, height: h, viewBox: '0 0 ' + w + ' ' + h, 'aria-hidden': 'true', focusable: 'false' });
    var defs = el('defs', {});
    var mask = el('mask', { id: id, maskUnits: 'userSpaceOnUse', x: -10, y: -10, width: w + 20, height: h + 20 });
    var rv = el('path', { d: d, class: 'rv', fill: 'none', stroke: '#fff', 'stroke-width': o.sw + 8, 'stroke-linecap': 'round', pathLength: 1, 'stroke-dasharray': '1 1', 'stroke-dashoffset': reduce ? 0 : 1 });
    mask.appendChild(rv);
    defs.appendChild(mask);
    svg.appendChild(defs);
    var st = el('path', { d: d, fill: 'none', stroke: o.color || PINK, 'stroke-width': o.sw, 'stroke-linecap': 'round', 'stroke-dasharray': o.dash, mask: 'url(#' + id + ')' });
    svg.appendChild(st);
    return { svg: svg, rv: rv };
  }

  function ease(t) { return 1 - Math.pow(1 - t, 3.2); }

  /* Animación por tiempo (cámara lenta) */
  function sew(parts, dur, delay, onDone) {
    if (reduce) { parts.forEach(function (p) { p.setAttribute('stroke-dashoffset', 0); }); if (onDone) onDone(); return; }
    var t0 = null;
    function f(t) {
      if (t0 === null) t0 = t + delay;
      var k = Math.min(1, Math.max(0, (t - t0) / dur));
      var v = (1 - ease(k)).toFixed(4);
      parts.forEach(function (p) { p.setAttribute('stroke-dashoffset', v); });
      if (k < 1) requestAnimationFrame(f); else if (onDone) onDone();
    }
    requestAnimationFrame(f);
  }

  /* 1) Subrayado cosido bajo un texto (una línea por cada renglón) */
  function underline(target, host, opts) {
    if (!target || !host) return;
    host.classList.add('bm-hilo-host');
    host.querySelectorAll('.bm-ul').forEach(function (n) { n.remove(); });
    var hb = host.getBoundingClientRect();
    var rects = Array.prototype.slice.call(target.getClientRects()).filter(function (r) { return r.width > 24; });
    if (!rects.length) return;
    rects = rects.slice(-1); /* solo el último renglón: con interlineado apretado no pisa la línea de abajo */
    var parts = [];
    rects.forEach(function (r) {
      var w = Math.round(r.width), h = 14;
      var s = stitchSVG(w, h, wave(w, h, opts.amp, opts.seg), { sw: opts.sw, dash: opts.dash, color: opts.color });
      s.svg.setAttribute('class', 'bm-ul');
      s.svg.style.left = (r.left - hb.left) + 'px';
      s.svg.style.top = (r.bottom - hb.top - r.height * (opts.lift || 0) + opts.gap) + 'px'; /* sube al pie real de las mayúsculas */
      host.appendChild(s.svg);
      parts.push(s.rv);
    });
    var per = opts.dur / parts.length;
    (function chain(i) {
      if (i >= parts.length) return;
      sew([parts[i]], per, i === 0 ? opts.delay : 0, function () { chain(i + 1); });
    })(0);
  }

  /* 2) Costura con aguja ligada al scroll */
  function seam(section) {
    if (!section || section.querySelector('.bm-seam')) return;
    var wrap = document.createElement('div');
    wrap.className = 'bm-seam';
    wrap.setAttribute('aria-hidden', 'true');
    section.insertBefore(wrap, section.firstChild);
    var cap = document.createElement('span');
    cap.className = 'bm-seam-cap';
    cap.textContent = 'Cosido en nuestro taller · Guardamar del Segura';

    function build() {
      wrap.querySelectorAll('svg,.bm-needle').forEach(function (n) { n.remove(); });
      var w = Math.max(200, wrap.clientWidth - 40), h = 22;
      var d = wave(w, h, 3.2, 120);
      var s = stitchSVG(w, h, d, { sw: 2.2, dash: '9 7' });
      wrap.appendChild(s.svg);
      var nd = document.createElement('span');
      nd.className = 'bm-needle';
      nd.innerHTML = '<svg viewBox="0 0 30 8" width="30" height="8"><path d="M0 2.6 Q-.6 4 0 5.4 L29 4.2 Q30 4 29 3.8 Z" fill="#d7dadd"/><ellipse cx="3.4" cy="4" rx="1.8" ry=".7" fill="#0A0A0A"/></svg>';
      nd.style.offsetPath = "path('" + d + "')";
      wrap.appendChild(nd);
      if (!wrap.contains(cap)) wrap.appendChild(cap);
      return { rv: s.rv, nd: nd };
    }
    var parts = build();

    if (reduce) { parts.rv.setAttribute('stroke-dashoffset', 0); wrap.classList.add('is-done'); return; }

    if (hasTL) {
      wrap.classList.add('tl');
      var chk = function () {
        if (wrap.getBoundingClientRect().top < innerHeight * 0.45) { wrap.classList.add('is-done'); removeEventListener('scroll', chk); }
      };
      addEventListener('scroll', chk, { passive: true });
      chk();
    } else {
      /* Respaldo: progreso calculado con el scroll (sin bloquear) */
      var ticking = false;
      var upd = function () {
        ticking = false;
        var r = wrap.getBoundingClientRect();
        var vh = innerHeight;
        var start = vh * 0.95, end = vh * 0.35;
        var p = Math.min(1, Math.max(0, (start - r.top) / (start - end)));
        parts.rv.setAttribute('stroke-dashoffset', (1 - p).toFixed(4));
        parts.nd.style.offsetDistance = (p * 100).toFixed(2) + '%';
        parts.nd.style.opacity = Math.min(1, p * 12, (1 - p) * 12);
        if (p >= 1) wrap.classList.add('is-done');
      };
      var on = function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } };
      addEventListener('scroll', on, { passive: true });
      upd();
    }

    var lw = wrap.clientWidth;
    addEventListener('resize', debounce(function () {
      if (wrap.clientWidth === lw) return;
      lw = wrap.clientWidth;
      parts = build();
      if (wrap.classList.contains('is-done') || hasTL) parts.rv.removeAttribute('stroke-dashoffset');
    }, 200));
  }

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function init() {
    addCSS();
    var tpl = (document.getElementById('MainContent') || {}).dataset ? document.getElementById('MainContent').dataset.template || '' : '';

    /* Portada */
    var em = document.querySelector('.bm-hero h1 em');
    if (em) {
      var h1 = em.closest('h1');
      var heroOpts = { amp: 1.6, seg: 26, sw: 2.6, dash: '7 6', gap: 0, lift: 0.24, dur: 1700, delay: 450 };
      var run = function () { underline(em, h1, heroOpts); };
      (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(run);
      var lw = innerWidth;
      addEventListener('resize', debounce(function () { if (innerWidth === lw) return; lw = innerWidth; heroOpts.delay = 0; heroOpts.dur = 1; run(); }, 200));
    }

    /* Colecciones: subrayado bajo el H1 */
    if (/^collection/.test(tpl)) {
      var ch = document.querySelector('#MainContent h1');
      if (ch && ch.textContent.trim()) {
        var span = ch.querySelector('.bm-h1t');
        if (!span) {
          span = document.createElement('span');
          span.className = 'bm-h1t';
          while (ch.firstChild) span.appendChild(ch.firstChild);
          ch.appendChild(span);
        }
        var cOpts = { amp: 1.4, seg: 24, sw: 2.2, dash: '6 5', gap: 0, lift: 0.2, dur: 1300, delay: 250 };
        var runC = function () { underline(span, ch, cOpts); };
        (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(runC);
        var lw2 = innerWidth;
        addEventListener('resize', debounce(function () { if (innerWidth === lw2) return; lw2 = innerWidth; cOpts.delay = 0; cOpts.dur = 1; runC(); }, 200));
      }
    }

    /* Bloque «Nuestro taller» */
    seam(document.querySelector('.bmw-wrap'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
